import React from "react";
import { AlertDialog, DialogContainer } from "@adobe/react-spectrum";

class DeleteConfirmModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = { isOpen: false };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.isOpen !== this.props.isOpen) {
      this.setState({ isOpen: this.props.isOpen });
    }
  }

  onOpenChange = (isOpen) => {
    this.setState({ isOpen });
    if (!isOpen) {
      this.props.onCancel();
    }
  };

  render() {
    const { onCancel, onConfirm, translate } = this.props;
    const { isOpen } = this.state;

    return (
      <DialogContainer isDismissable={false} onDismiss={() => this.onOpenChange(false)}>
        {isOpen && (
          <AlertDialog
            title={translate("smart_flag_profile_delete_confirm_title")}
            variant="destructive"
            primaryActionLabel={translate("general_delete")}
            secondaryActionLabel={translate("general_cancel")}
            onPrimaryAction={onConfirm}
            onSecondaryAction={onCancel}
          >
            {translate("smart_flag_profile_delete_confirm_text")}
          </AlertDialog>
        )}
      </DialogContainer>
    );
  }
}

export default DeleteConfirmModal;
